import * as React from 'react';

import { Label } from './label';
import { Input, InputProps } from './input';
import Spacer from '@/common/components/spacer';
export interface InputWithLabelProps extends InputProps {
  label: string;
}

const InputWithLabel = React.forwardRef<HTMLInputElement, InputWithLabelProps>(
  ({ variant = 'light', label, ...props }: InputWithLabelProps, ref) => {
    const inputId = label.replaceAll(/ /g, '');
    const labelId = inputId + '-label';
    return (
      <>
        <Label id={labelId} variant={variant}>
          {label}
        </Label>
        <Spacer variant="height4" />
        <Input
          {...props}
          variant={variant}
          aria-labelledby={labelId}
          id={inputId}
          ref={ref}
        />
      </>
    );
  }
);
InputWithLabel.displayName = 'InputWithLabel';

export { InputWithLabel };
